import '../styles/sections/homepage-hero.scss';
import "../sections/gallery-list";

document.addEventListener('DOMContentLoaded', () => {
    if (navigator.userAgent.match(/android/i)) {
        document.body.classList.add('device-android');
    }
});
